<script>
export default {
  props: {
    calculationResults: Object,
    isFormDirty: Boolean,
    selectedAssociatedCO2UnitOption: String
  }
};
</script>

<template>
  <div class="calculated-inner-wrapper">
    <div class="calculated-row">
      <div class="calculated-row-title">Estimated Lifetime CO<sup>2</sup> Creation</div>
      <div class="calculated-row-value">{{
          Number(calculationResults.co2Creation).toLocaleString('en-US', {
            maximumFractionDigits: 0
          })
        }} {{ selectedAssociatedCO2UnitOption === 'Lb/kWh' ? 'Lb' : 'kg' }}
      </div>
    </div>
    <div class="calculated-row">
      <div class="calculated-row-title">Estimated Lifetime energy consumption</div>
      <div class="calculated-row-value">{{
          Number(calculationResults.energyConsumption).toLocaleString('en-US', {
            maximumFractionDigits: 0
          })
        }} kWh
      </div>
    </div>
    <div class="calculated-row">
      <div class="calculated-row-title">Estimated Lifetime energy cost</div>
      <div class="calculated-row-value">{{
          Number(calculationResults.energyCost).toLocaleString('en-US', {
            style: 'currency',
            currency: 'USD',
            maximumFractionDigits: 0
          })
        }}
      </div>
    </div>
    <div class="calculated-row">
      <div class="calculated-row-title">Drive efficiency</div>
      <div
          class="calculated-row-value"
          :class="{'is-drive-green': calculationResults.isDriveGreen}"
      >
        {{
          Number(calculationResults.driveEfficiency).toLocaleString('en-US', {
            maximumFractionDigits: 2
          })
        }} %
      </div>
    </div>
    <div class="calculated-row">
      <div class="calculated-row-title">Relative Efficiency Savings</div>
      <div
          class="calculated-row-value"
          :class="{'is-efficiency-green': calculationResults.isEfficiencyGreen, 'is-efficiency-white': calculationResults.isEfficiencyWhite }"
      >
        {{
          Number(calculationResults.efficiencySavings).toLocaleString('en-US', {
            style: 'currency',
            currency: 'USD',
            maximumFractionDigits: 0
          })
        }}
      </div>
    </div>
    <div v-if="isFormDirty" class="overlay"></div>
  </div>
</template>

<!--<style scoped>-->
<style>
.calculated-row {
  /*width: 80%;*/
  margin: 0 auto;
  border-bottom: 1px solid #dadada;
  padding: 10px;
}

.calculated-row-title {
  font-size: 13px;
}

.calculated-row-value {
  text-align: center;
  font-size: 20px;
  padding: 5px 0 0;
}

.overlay {
  width: 100%;
  height: 100%;
  position: absolute;
  background-color: white;
  z-index: 100;
  top: 0;
  left: 0;
  opacity: 75%;
}

.calculated-inner-wrapper {
  position: relative;
}

.is-drive-green {
  color: var(--green);
}

.is-efficiency-green {
  color: var(--green);
}

.is-efficiency-green::first-letter {
  color: var(--white);
}

.is-efficiency-white {
  color: var(--white);
}
</style>
